const config = {
  clientShortName: 'vtr',
  title: 'VTR',
  email: 'info@toolboxtve.com'
}

export default config;
